// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mainNavigationStyles } from "@eisinc/Overrides/Widgets/Header/MainNavigation";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

mainNavigationStyles.container = {
    css: css`
        color: ${color("common.background")};
        display: flex;
        gap: 8px;
        justify-content: left;
    `,
};

mainNavigationStyles.itemWrapper = {
    css: css`
        position: relative;
        overflow: visible;
        display: flex;
        gap: 8px;
        &:hover span + div {
            display: block;
        }
    `,
};

mainNavigationStyles.menuItem = {
    css: css`
        display: flex;
        align-items: center;
        height: 34px;
        padding: 0 12px;
        margin: 0;
        ${IconWrapper} {
            color: ${color("secondary.contrast")};
        }
        &:hover {
            background-color: ${color("primary.contrast")};
            p,
            span,
            svg {
                color: ${color("text.main")} !important;
            }
        }
        --text-main: ${color("text.main")};
    `,
};

mainNavigationStyles.menuItemIcon = {
    size: 12,
    color: "secondary.contrast",
    css: css`
        margin: 0;
    `,
};

mainNavigationStyles.menuItemTypography = {
    size: 14,
    lineHeight: "17px",
    color: "primary.contrast",
    weight: fontConfig.weight.medium,
    css: css`
        display: flex;
        gap: 6px;
        align-items: center;
        &&& ${IconWrapper} {
            color: ${color("common.white")};
        }
    `,
};

mainNavigationStyles.cascadingMenu = {
    cssOverrides: {
        menuItem: css`
            a {
                color: ${color("text.main")} !important;
                &:hover {
                    background-color: ${color("common.ui2")} !important;
                    color: ${color("text.main")} !important;
                }
            }
        `,
    },
};
